import { render, staticRenderFns } from "./BotaoListaArmazem.vue?vue&type=template&id=f91710e4&lang=pug"
import script from "./BotaoListaArmazem.vue?vue&type=script&lang=js"
export * from "./BotaoListaArmazem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports